import {usePrefetchMaterials, usePrefetchMaterialsRecipes} from '@domain/materials'
import {DefaultLoadingComponent} from '@hconnect/uikit/src/lib2/components/loadingSwitcher/DefaultLoadingComponent'
import {UpmPlantProvider, useUpmPlantsContext} from '@hconnect/upm'
import {usePermissionsParsedQuery} from '@hproduce/permissions'
import {useQueryErrorResetBoundary} from '@tanstack/react-query'
import {Outlet, useNavigate} from 'react-router'

import {PlannerErrorBoundary} from '../../shared/components/errorBoundary/PlannerErrorBoundary'
import {GuidedToursShell} from '../../shared/components/GuidedToursShell'
import {DialogProvider} from '../../shared/components/providers/DialogProvider'
import {PlannerToursProvider} from '../../shared/components/providers/PlannerToursProvider'
import {usePlantAccessQuery} from '../../shared/hooks/api'
import {useUrlParam} from '../../shared/hooks/useUrlParam'

export const PagePlant: React.FC = () => {
  const plantCode = useUrlParam('plantCode')

  const upmPlants = useUpmPlantsContext({isInitialLoad: true})
  const currentPlant = upmPlants?.[plantCode]
  const {isSuccess: isPlantAccessible} = usePlantAccessQuery(plantCode)
  const {data: permissions} = usePermissionsParsedQuery()

  usePrefetchMaterials(plantCode)
  usePrefetchMaterialsRecipes(plantCode)

  const navigate = useNavigate()
  const refreshPage = () => navigate(0)
  const {reset} = useQueryErrorResetBoundary()

  if (!isPlantAccessible || !permissions || !upmPlants || !currentPlant) {
    return <DefaultLoadingComponent isLoading />
  }

  return (
    <UpmPlantProvider plantUpmId={currentPlant.upmId}>
      <DialogProvider>
        <PlannerToursProvider>
          <GuidedToursShell>
            <PlannerErrorBoundary
              onRetry={reset}
              fallbackSx={{width: 'auto', maxWidth: ({spacing}) => spacing(60)}}
              fallbackWrapperSx={{
                flexGrow: 1,
                justifyContent: 'center',
                alignItems: 'center'
              }}
              fallbackTestId="page_plant_error_boundary_fallback"
              onReload={refreshPage}
            >
              <Outlet />
            </PlannerErrorBoundary>
          </GuidedToursShell>
        </PlannerToursProvider>
      </DialogProvider>
    </UpmPlantProvider>
  )
}
